<template>
  <div id="questions">
    <!-- 说明文档 -->
    <div class="header">常见问题汇总</div>
    <ul>
      <li>
        <p class="title"><i></i>1、 什么是兑换码？</p>
        <p>
          答：兑换码是一段串码，由10-15位数字组成。此码需要在【趣悦服务】平台进行激活，激活后根据兑换券内容可兑换为趣豆或礼包，趣豆可在平台上进行消费使用，礼包可直接使用也可转让变现。
        </p>
      </li>

      <li>
        <p class="title"><i></i> 2、 趣豆、礼包有效期？</p>
        <p>
          答：兑换码激活起开始计算有效期，到期后趣豆、礼包均无法使用。
        </p>
      </li>

      <li>
        <p class="title"><i></i>3、 使用趣豆支付兑换商品可以退/换吗？</p>
        <p>
          答：平台提供的商品均为电子卡密或直接充值类商品，一旦支付兑换完成，将无法进行退/换货处理，如有问题请提交售后联系平台管理员处理。
        </p>
      </li>

      <li>
        <p class="title"><i></i>4、 趣豆支付兑换商品后，多久能收到？</p>
        <p>
          答：正常情况支付成功后，直充类及电子卡密类商品均在2小时以内处理完成，请您关注账户及手机短信内容。如遇特殊情况可联系平台管理员处理。
        </p>
      </li>
      <li>
        <p class="title">
          <i></i>5、 油卡充值之后，收到充值成功的通知，但是无法直接使用？
        </p>
        <p>
          答：通过本平台对加油卡进行充值后，需携带加油卡到加油站柜台进行圈存，圈存成功后您的加油卡内将显示充值后的余额。
        </p>
      </li>
      <li>
        <p class="title"><i></i>6、平台管理员在线时间？</p>
        <p>
          答：平台管理员电话：
          ，服务时间为周一到周五的早9:00-晚18:00（法定节假日除外）。
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
#questions {
  .header {
    padding: 48px 60px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    font-size: 30px;
    color: #1fbe6e;
  }
  ul > li {
    padding: 0 58px 30px;
    .title {
      font-family: PingFang-SC-Bold;
      font-size: 26px;
      line-height: 24px;
      font-weight: bold;
      color: #575757;
      padding-bottom: 20px;
      position: relative;
      i {
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #575757;
        border-radius: 100%;
        left: -20px;
        top: 5px;
      }
    }
    p {
      font-family: PingFang-SC-Regular;
      font-size: 24px;
      line-height: 32px;
      color: #575757;
    }
  }
}
</style>
